import { Component, PLATFORM_ID, Inject } from '@angular/core'; import { isPlatformBrowser } from '@angular/common';
// import { Meta, Title } from '@angular/platform-browser';
;
@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss']
})
export class HomeComponent {
    isPlat = false;
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        // private titleService: Title,
        // private meta: Meta
    ) { }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.isPlat = true;
        }
        // this.titleService.setTitle("O’Delice - Pizzeria tremblay en france ");
        // this.meta.addTag({ name: 'description', content: "Votre restaurant O'DELICE vous livre à domicile et au bureau vos plats préférés à tremblay en france et les villes aux alentours. Vous pouvez commandez en ligne facilement" });
        // this.meta.addTag({ name: 'keywords', content: "livraison pizza, pizza livraison, livraison  O’Delice commander pizza en ligne, pizza, livraison à domicile, livraison O'DELICE, livraison gratuite, burger, pizzas, site commander pizza, pizza à domicile, pizzeria vaujours, commander à emporter, pizza emporter, pizzas, livraison nourriture, numéro pizzeria, livreur de pizza, commander une pizza" })
    }
}
